import { useWebsiteSettings } from 'client/store'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import React, { useRef } from 'react'
import {
  ButtonWithTypeProps,
  SecondaryButton,
} from 'src/editor/shared/ui-lib/buttons'
import {
  getCurrentWebsiteLocale,
  getWebsiteLocale,
} from 'src/editor/store/website-settings/website-settings-selector'
import { Tooltip } from 'src/shared/components/tooltip'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { twJoin } from 'tailwind-merge'

interface DuplicatePagesBannerProps {
  localesCount: Record<PageLocaleEnum, number>
  buttonProps: Omit<ButtonWithTypeProps, 'children'>
}

export const DuplicatePagesBanner = ({
  localesCount,
  buttonProps,
}: DuplicatePagesBannerProps) => {
  const { t } = useTypedTranslation()
  const ref = useRef<HTMLDivElement>(null)
  const websiteLocale = useWebsiteSettings(getWebsiteLocale) as PageLocaleEnum
  const currentWebsiteLocale = useWebsiteSettings(
    getCurrentWebsiteLocale,
  ) as PageLocaleEnum

  const missedPagesCount =
    localesCount[websiteLocale] - localesCount[currentWebsiteLocale]
  return missedPagesCount > 0 && localesCount[currentWebsiteLocale] > 0 ? (
    <>
      <div
        ref={ref}
        className={twJoin(
          'absolute right-5 bottom-5 left-5 flex items-center justify-between gap-3',
          'rounded-[10px] bg-bgWarning p-2',
        )}
      >
        <span className="flex items-center text-M text-secondary">
          {t('pages_management.duplicate_pages_banner.label_icu', {
            count: missedPagesCount,
          })}
          <Tooltip
            message={'pages_management.duplicate_pages_banner.tooltip'}
          />
        </span>

        <SecondaryButton {...buttonProps}>
          {t('pages_management.duplicate_pages_banner.button')}
        </SecondaryButton>
      </div>
      {/* NOTE: we need it to have a space under the banner — prevent hiding the content by the banner  */}
      <div style={{ height: ref.current?.clientHeight }} />
    </>
  ) : null
}
